"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var firestore_1 = require("firebase/firestore");
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var DropdownButton_1 = __importDefault(require("atomicComponents/molecules/Buttons/DropdownButton"));
var DropdownMenu_1 = __importDefault(require("shared/components/DropdownMenu"));
var DropdownOption_1 = __importDefault(require("shared/components/DropdownMenu/DropdownOption"));
var backend_1 = require("utils/backend");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var PlanRulesDropdown = function (_a) {
    var _b;
    var item = _a.item;
    var _c = __read(react_1.default.useState(null), 2), anchorEl = _c[0], setAnchorEl = _c[1];
    var rechargerCompany = (0, react_redux_1.useSelector)(single_1.selectMyRechargerCompany);
    var _d = __read((0, backend_1.useCall)('misc-excludeplanrecharges', {
        companyId: rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id, rechVendorId: item.rechVendorId, plan: item.name,
    }), 2), excludeExisting = _d[0], isExcludeExisting = _d[1];
    var _e = __read((0, hooks_1.useSubmitter)('recharger_companies', rechargerCompany === null || rechargerCompany === void 0 ? void 0 : rechargerCompany.id, {
        excludedPlansMap: (_b = {}, _b[item.rechVendorId] = item.isExcluded ? (0, firestore_1.arrayRemove)(item.name) : (0, firestore_1.arrayUnion)(item.name), _b),
    }), 2), toggleExclusion = _e[0], isToggling = _e[1];
    var handleClick = function (event) { return setAnchorEl(anchorEl ? null : event.currentTarget); };
    var handleOnClose = function () { return setAnchorEl(null); };
    var disableOptions = isExcludeExisting || isToggling;
    var handleExclusion = function () {
        toggleExclusion();
        handleOnClose();
    };
    var handleExcludeExisting = function () {
        excludeExisting()();
        handleOnClose();
    };
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ ml: -2 }, { children: [(0, jsx_runtime_1.jsx)(DropdownButton_1.default, __assign({ outlined: true, onClick: handleClick, isOpen: !!anchorEl, disabled: disableOptions, color: item.isExcluded ? 'red' : 'neutral', className: "highlightInput" }, { children: item.isExcluded ? 'Excluded' : 'Included' })), (0, jsx_runtime_1.jsxs)(DropdownMenu_1.default, __assign({ anchorEl: anchorEl, keepMounted: true, open: !!anchorEl, onClose: handleOnClose }, { children: [item.isExcluded && ((0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "Exclude existing charges", titleColor: "red", description: "Applies to charges in draft invoices and new. It doesn\u2019t apply to invoiced charges.", onClick: handleExcludeExisting, disabled: disableOptions })), (0, jsx_runtime_1.jsx)(DropdownOption_1.default, { title: "".concat(item.isExcluded ? 'Include' : 'Exclude', " plan"), titleColor: item.isExcluded ? 'green' : 'red', description: "Applies only to future charges with this plan name imported to Rechargly.", onClick: handleExclusion, disabled: disableOptions })] }))] })));
};
exports.default = PlanRulesDropdown;
